export const MS = 1;
export const SECOND = 1000 * MS;
export const MINUTE = 60 * SECOND;

export const QUERY_RETRY_DELAY = 500 * MS;
